// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PAb_s","newExpiryDate":"styles_newExpiryDate__1ZFPm","footer":"styles_footer__3-EZy"};